import {styled} from 'common'
import {Colors} from 'appearance'
import {
    Checkbox as RawCheckbox,
    FormGroup,
    FormControlLabel,
} from '@mui/material'

const Input = ({label, disabled, defaultChecked, ...p}) => {
    if (label) {
        return (
            <FormGroup {...p}>
                <FormControlLabel
                    control={
                        <RawCheckbox
                            sx={{
                                color: Colors.APP_GRAY_DARK,
                                '&.Mui-checked': {
                                    color: Colors.BLUE,
                                },
                            }}
                            defaultChecked={defaultChecked}
                        />
                    }
                    label={label}
                    disabled={disabled}
                />
            </FormGroup>
        )
    }

    return <RawCheckbox {...p} defaultChecked />
}
export default styled(Input)``
